import invariant from 'tiny-invariant'

import useCurrentCompanyOrFail from '@/hooks/useCurrentCompanyOrFail'
import { ROUTES } from '@/lib/routes'

export function useCompanyCompassLink() {
  const currentCompany = useCurrentCompanyOrFail()
  const referralCode = currentCompany.referralCode

  invariant(referralCode, 'Could not find referral code for current company.')

  const companyCompassInvitePath = ROUTES.companyCompassInvite({
    params: { companyReferralCode: referralCode },
  })

  return `${window.location.origin}${companyCompassInvitePath}`
}
